const CONSTANTS = require('../../lib/constants');
const utils     = require('../../lib/utils');

module.exports = {
	config: {
		closableTabs: true,
		focusAble:    true,
		environmentDependent: true,
		flexHeight: false,
		startWithRegisterSecret: '',
		maxWidthTabs: false,
		hideHeadContainingOneSingleElement: false,
		addRelationshipElementButtonsFormMapping: false,

		// extendDynamicTabs: {
		// 	newsTeaser: {										// this key is used as resourceRegisterKey for the tab action
		// 		type: 'ninja',									// dynamicTabTypes:
		// 															- ninja: 	ninja components are componentInstances associated with another resource and stored within cms_componentsInstances table.
		// 																		to keep these instances related to other database records the foreign key (parentEntityID) and the foreign table identifier (parentEntityType) will be stored.
		// 		tabOptions: {									// options used to define the tab. the chosen format is just like the one of normal tabs.
		// 			icon: 'fi fi-clock',
		// 			title: 'Teaser',
		// 			subTitle: 'Teaser für Startseite'
		// 		},
		// 		ninjaConfig: {									// ninja config details
		// 			ninjaType: 'news',							// this type identifies cms_componentsInstances.parentEntityType and cms_components.ninjaType .
		// 			ninjaCodeName: 'teaser',					// this codename in combination with ninjaType is used to identify the component (cms_components.ninjaCodeName) which should be used.
		// 			entityCodeName: 'homeTeaser',				// since it is possible to instantiate multiple ninjaComponents per parent record of the same ninjaType and ninjaCodeName this entityCodeName is used to keep them apart.
		// 														   furthermore it identifies the componentInstance via cms_componentsInstances.entityCodeName.
		// 														   this flag has to be unique per ninjaType.
		// 			ninjaComponentType: 'instance',				// this flag defines how the cms should treat this ninjaInstance.
		// 														   available ninjaComponentTypes:
		// 																- instance: just one instance without children.
		// 																- WORK IN PROGRESS: tree: one instance including a full subTree of componentInstances.
		// 																- WORK IN PROGRESS: list: a list of instances including some features like user controllable sort.
		// 			autoCreateComponentInstance: true			// if this flag is set to false the user has to press a button in order to create the component instance.
		// 														   this may come in handy if one wants to prevent many empty componentInstances if they rarely have to be filled.
		// 														   if this flag is set to true the component will be instantiated if the cms wants to load its contents but cannot find it.
		// 		}
		// 	},
		// }
	},

	actions: {
		addTab: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {
				tab: {
					componentData: {
						component: [
							'base',
							'tabStrip',
							'tab'
						]
					}
				},
				tabContentContainer: {
					componentData: {
						type: 'component',
						subType: 'layout',
						component: [
							'base',
							'tabStrip',
							'tabContent'
						]
					}
				},
				// TODO: action source name should be "load" instead of tabContent. @see MARK: COMPONENT_IN_CHARGE_ACTION_SOURCE_NAME_DILEMMA
				tabContent: {
					componentData: {
						config: {
							lastMileSelector: '.tabContent'
						}
					},
					setParentViaActionSourceKey: 'tabContentContainer',
				}
			},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
			}
		},
	},

	events: {
		/**
		 * this function handles the Escape and Enter key-down-events
		 */
		keyboard: {
			type: 'keydown',
			action: function(event){
				switch(utils.keyboard.getKeyCode(event)){
					case 'esc':
						var registerSecret, registerEntry, tabComponent;
						if(
							(registerSecret = event.data.component.model.activeRegisterSecret) !== undefined &&
							(registerEntry = event.data.component.registry[registerSecret]) &&
							(tabComponent = registerEntry.tab) &&
							tabComponent.config.closable
						){
							event.data.component.removeTab(registerSecret);
						}
						break;
				}
			}
		}
	},

	model: {
		activeRegisterSecret: '',
		actualNrOfDynamicTabs: 0,
		removeTabsWhenReady: {}
	},

	methods: {


		/**
		 * this function calculates the widths of the tabs and appends a class to the tabStrip if sum of tab-widths is bigger then the tabStrip's width
		 */
		calculateTabStripDisplayType: function(){
			var tabComponent;
			if (
				(tabComponent = ((this.registry || [])[0] || {}).tab)
				&&
				(tabComponent.$ || []).length > 0
			){
				var tabItemHeight = Math.ceil(this.registry[0].tab.$.outerHeight(true));
				var $tabSection = this.$.find("> section.tabs");

				// set class "detachedTabs" if sum of tab-withs is bigger then width of tab-strip
				if((2 * tabItemHeight) < $tabSection.outerHeight(true)){
					if(!this.$.hasClass('detachedTabs')){
						this.$.addClass('detachedTabs');
					}
				} else {
					if(this.$.hasClass('detachedTabs')) {
						this.$.removeClass('detachedTabs');
					}
				}
			}
		},

		/**
		 * environment has been updated (resize)
		 */
		onEnvironmentUpdated: function(){
			this.calculateTabStripDisplayType();
		},

		/**
		 * this function is used to perform the needed load actions for a tab and a tabContent extended by selective data from the original tabAction given.
		 *
		 * @param   data                                    mixed - PromiseContext of tab-action
		 * @returns int                                     registerSecret of the new tab
		 */
		addTab: function(data){
			// init
			var self = this;
			var nextRegisterSecret = this.model.actualNrOfDynamicTabs++;

			const dataComponent = data.component || {}
			for(const actionSourceName of ['tab', 'tabContentContainer', 'tabContent']){
				let closable
				if(actionSourceName === 'tab') closable = self.config.closableTabs;

				data.action.source[actionSourceName] = data.action.source[actionSourceName] || {}
				data.action.source[actionSourceName].componentData = data.action.source[actionSourceName].componentData || {}
				data.action.source[actionSourceName].componentData.originalActionParentComponentIndex = dataComponent.componentIndex
				data.action.source[actionSourceName].componentData.originalParentActionKey = data.action.key

				if(actionSourceName !== 'tabContent'){
					data.action.source[actionSourceName].componentData.config = utils.replace(data.action.source[actionSourceName].componentData.config || {}, {
						registerSecret: nextRegisterSecret,
						closable
					})
				}
			}

			// this is necessary to preserve the order of dynamic tabs in cases where later added tabs may be ready sooner than earlier added ones.
			const actionKey = `addElement_${this.getNextActionIndex()}`
			const lastUsedActionKey = self.model.lastUsedActionKey
			self.model.lastUsedActionKey = actionKey

			return this.performAndStoreAction(
				actionKey,
				this.prepareAction(
					'addTab',
					undefined,
					data.action.resourceRegister,
					{
						source: {
							tab: {
								componentData: 			data.action.source.tab.componentData,
								resourceRegisterKey:    data.action.source.tab.resourceRegisterKey
							},
							tabContentContainer: {
								componentData: 			data.action.source.tabContentContainer.componentData,
								resourceRegisterKey:    data.action.source.tabContent.resourceRegisterKey
							},
							tabContent: data.action.source.tabContent
						},
						waitForActionID: lastUsedActionKey
					}
				)
			).then(data => {
				// save tab connection
				data.action.tabConnection = {
					tabStripComponentIndex: self.componentIndex,
					tabRegisterSecret: nextRegisterSecret
				};

				// extend registry by tabContent-component
				this.registry = this.registry || {}
				const registry = this.registry[nextRegisterSecret] || {}
				const actionSource = (data.action || {}).source || {}
				if(actionSource.tabContent.component){
					registry.tabContent = actionSource.tabContent.component
				} else {
					const componentTree = actionSource.tabContent.componentTree || {}
					if(componentTree.childLayoutIndex !== undefined && (componentTree.children || [])[componentTree.childLayoutIndex]){
						registry.tabContent = componentTree.children[componentTree.childLayoutIndex]
					} else {
						console.error('could not register tabContent')
					}
				}

				// focus new tab if granted
				if(((((((data || {}).action || {}).source || {}).tab || {}).component || {}).resourceData || {}).grantAutoFocus !== false){
					self.focusTab(nextRegisterSecret);
				}

				// re-calculate tab-strip
				self.calculateTabStripDisplayType();

				self.updateStates();

				// return promise data
				return utils.promise.resolve(data);
			}).fail(function(data){
				data.action.tabConnection = {
					tabStripComponentIndex: self.componentIndex,
					tabRegisterSecret: nextRegisterSecret
				};

				// cleanup dynamic action components and it's actions in case of an error
				utils.forEach(self.actions, function(action, actionKey){
					if(
						action.source.tab &&
						action.source.tab.component &&
						action.source.tab.component.config.registerSecret != undefined &&
						action.source.tab.component.config.registerType != undefined &&
						(
							!self.registry[action.source.tab.component.config.registerSecret] ||
							!self.registry[action.source.tab.component.config.registerSecret][action.source.tab.component.config.registerType]
						)
					){
						action.source.tab.component.destroy();
						action.source.tabContentContainer.component.destroy();
					}
				});

				return utils.promise.reject(data);
			});
		},

		/**
		 * this function is used to destroy a tab inclusive it's contents completely
		 *
		 * @param registerSecret
		 */
		removeTab: function(registerSecret, restoreActiveTab = false){
			// for deactivation issues focus tab before actual tab destruction.
			var registryKeys = Object.keys(this.registry);
			var restoreRegisterSecret;
			if(restoreActiveTab){
				restoreRegisterSecret = this.model.activeRegisterSecret;
			}

			if(registryKeys.length > 0){
				if(registerSecret == this.model.activeRegisterSecret || this.model.activeRegisterSecret == ''){
					registryKeys = this.getSortedRegisterSecrets();
					var lastRegistryKey = registryKeys.pop();
					if(lastRegistryKey == registerSecret){
						if(registryKeys.length > 0){
							lastRegistryKey = registryKeys.pop();
						}
						else {
							if(this.registry[lastRegistryKey].tab)          		this.registry[lastRegistryKey].tab.deactivate(true);
							if(this.registry[lastRegistryKey].tabContentContainer)  this.registry[lastRegistryKey].tabContentContainer.deactivate(true);
							lastRegistryKey = undefined;
						}
					}
					if(lastRegistryKey != undefined) this.focusTab(restoreRegisterSecret !== undefined ? restoreRegisterSecret : lastRegistryKey);
				}
				else {
					this.focusTab(this.model.activeRegisterSecret, true);
				}
			} else if(!this.config.isReady){
				this.model.removeTabsWhenReady[registerSecret] = true
			}

			// destroy tab which should be removed
			if(registerSecret != undefined && this.registry[registerSecret]){
				// NOTE:    the Component.prototype.destroy() method is able to remove parents' registry entries if they are empty.
				//          so this doubled proofing of the registry entry is necessary sometimes.
				//          (e.g., in case of an action rollback because of an error during tab content load)
				// NOTE: 	tabContent is present within the registry if and only if this was a dynamic loaded tab. if the tabContent has been created within the cms as tree element, the tabContent-component is a real child of the tabContentContainer.
				if(this.registry[registerSecret] && this.registry[registerSecret].tab)           			this.registry[registerSecret].tab.remove();
				if(this.registry[registerSecret] && this.registry[registerSecret].tabContentContainer)    	this.registry[registerSecret].tabContentContainer.remove();
				if(this.registry[registerSecret] && this.registry[registerSecret].tabContent)    			this.registry[registerSecret].tabContent.destroy();
			}

			// re-calculate tab-strip
			this.calculateTabStripDisplayType();

			this.updateStates();
		},

		/**
		 * hide a tab-head identified by registerSecret.
		 *
		 * @param   registerSecret        int - registerSecret
		 */
		hideTab: function(registerSecret){
			var components = (this.registry || {})[registerSecret];
			if(components){
				components.tab.$.css({
					width: 0,
					height: 0,
					padding: 0,
					margin: 0,
					'border-width': 0,
					opacity: 0,
					overflow: 'hidden'
				});
			}
		},

		/**
		 * removes all tabs from this tabStrip.
		 */
		clearTabs: function(){
			this.model.actualNrOfDynamicTabs = 0;

			for(const registerSecret in this.registry){
				// NOTE:    the Component.prototype.destroy() method is able to remove parents' registry entries if they are empty.
				//          so this doubled proofing of the registry entry is necessary sometimes.
				//          (e.g., in case of an action rollback because of an error during tab content load)
				// NOTE: 	tabContent is present within the registry if and only if this was a dynamic loaded tab. if the tabContent has been created within the cms as tree element, the tabContent-component is a real child of the tabContentContainer.
				if(this.registry[registerSecret].tab)           		this.registry[registerSecret].tab.remove();
				if(this.registry[registerSecret].tabContentContainer)   this.registry[registerSecret].tabContentContainer.remove();
				if(this.registry[registerSecret].tabContent)    		this.registry[registerSecret].tabContent.destroy();
			}
		},

		/**
		 * this function is used to focus a tab identified by the given registerSecret.
		 *
		 * @param   registerSecret        int - registerSecret
		 * @param   forceHandlers         boolean - should the handler execution be forced?
		 * @returns boolean - success (may be false if tab not found according to given registerSecret)
		 */
		focusTab: function(registerSecret, forceHandlers){
			this.model.activeRegisterSecret = registerSecret;
			var self = this;

			utils.forEach(this.registry, function(registerElement, registerElementSecret){
				if(registerSecret != registerElementSecret){
					if(registerElement.tab) 				registerElement.tab.deactivate(forceHandlers);
					if(registerElement.tabContentContainer) registerElement.tabContentContainer.deactivate(forceHandlers);
				}
			});

			if(registerSecret != undefined && this.registry[registerSecret]){
				if(this.registry[registerSecret].tab)           		this.registry[registerSecret].tab.activate(forceHandlers);
				if(this.registry[registerSecret].tabContentContainer)   this.registry[registerSecret].tabContentContainer.activate(forceHandlers);

				// when a tab will be displayed bold after activation the with needed can change.
				this.calculateTabStripDisplayType();
				return true;
			}

			return false;
		},

		/**
		 * this function is used to focus the next available tab in the actual tab list
		 * NOTE: if the last tab is the actual one, the first tab will be focused.
		 */
		focusNextTab: function(){
			var tabSecrets, activationTabRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				tabSecrets = Object.keys[this.registry];
				if(tabSecrets.length > 0) activationTabRegisterSecret = tabSecrets.shift();
			}
			else {
				tabSecrets = Object.keys[this.registry];
				var nextTabSecretIndex = tabSecrets.indexOf(this.model.activeRegisterSecret) + 1;
				if(tabSecrets.length > nextTabSecretIndex && nextTabSecretIndex >= 0) activationTabRegisterSecret = tabSecrets[nextTabSecretIndex];
			}

			if(activationTabRegisterSecret != undefined) this.focusTab(activationTabRegisterSecret);
		},

		/**
		 * this function is used to focus the previous available tab in the actual tab list.
		 * NOTE: if the first tab is the actual one, the last tab will be focused.
		 */
		focusPreviousTab: function(){
			var tabSecrets, activationTabRegisterSecret;
			if(this.model.activeRegisterSecret == undefined){
				tabSecrets = Object.keys[this.registry];
				if(tabSecrets.length > 0) activationTabRegisterSecret = tabSecrets.pop();
			}
			else {
				tabSecrets = Object.keys[this.registry];
				var nextTabSecretIndex = tabSecrets.indexOf(this.model.activeRegisterSecret) - 1;
				if(tabSecrets.length > nextTabSecretIndex && nextTabSecretIndex >= 0) activationTabRegisterSecret = tabSecrets[nextTabSecretIndex];
			}

			if(activationTabRegisterSecret != undefined) this.focusTab(activationTabRegisterSecret);
		},

		/**
		 * this function is used to mark a tab with the given type.
		 *
		 * @param registerSecret		mixed - register secret of tab which should be marked
		 * @param type					string - mark type (at the moment: "validationError" | <empty string>)
		 */
		markTab: function(registerSecret, type){
			var tabComponent;
			if(type !== undefined && registerSecret !== undefined && this.registry[registerSecret] && (tabComponent = this.registry[registerSecret].tab)){
				tabComponent.mark(type);
			}
		},

		/**
		 * this function refreshes a tab and a tabContent component identified by the registerSecret and replaces the tabOptions within the tab-Component if necessary.
		 *
		 * @param registerSecret		int - register secret identifying the tab
		 * @param tabOptions			{} - optional - tabOptions used for tab head refresh
		 * @param refreshTabContent		boolean - default: false - should the tabContent component be refreshed too?
		 */
		refreshTab: function(registerSecret, tabOptions, refreshTabContent){
			var components = (this.registry || {})[registerSecret];
			if(components){
				utils.refReplace(components.tab.resourceData, tabOptions || {})
				components.tab.refresh(false)
				if(refreshTabContent){
					components.tabContentContainer.refresh()
					if(components.tabContent){
						components.tabContent.refresh()
					}
				}
			}
		},

		/**
		 * this function returns a tabComponent or a tabContentComponent according to the given params if possible.
		 *
		 * @param registerSecret 	int - register secret identifying the tab
		 * @param getTab			boolean - default: false - should the tabContent- or tab- component be returned
		 * @returns Component-Instance || false
		 */
		getTabComponent: function(registerSecret, getTab){
			var components = (this.registry || {})[registerSecret || -1];
			if(components){
				if(getTab) return components.tab;
				// TODO: maybe someone would like to get tabContent?
				// TODO: maybe the tabContent is not a child of tabContentContainer (@see addTab() dynamic added tabs)
				return components.tabContentContainer;
			}
			return false
		},

		/**
		 * this function returns an array containing register secrets naturally ordered.
		 *
		 * @returns {Array.<*>}
		 */
		getSortedRegisterSecrets: function(){
			var staticRegisterSecrets = Object.keys(this.registry);
			var dynamicRegisterSecrets = [];
			var staticRegisterSecretIndex;
			utils.forEach(this.actions, function(action){
				if(action.tabConnection && action.tabConnection.tabRegisterSecret != undefined){
					dynamicRegisterSecrets.push(action.tabConnection.tabRegisterSecret);
					staticRegisterSecretIndex = utils.indexOf(staticRegisterSecrets, action.tabConnection.tabRegisterSecret);
					if(staticRegisterSecretIndex >= 0) staticRegisterSecrets.splice(staticRegisterSecretIndex, 1);
				}
			});

			return staticRegisterSecrets.concat(dynamicRegisterSecrets);
		},

		/**
		 * this function is used to extend the tabStrip onBeforeRender by dynamic tabs defined within config.extendDynamicTabs object.
		 */
		extendDynamicTabs: function(){
			const dynamicTabs = this.config.extendDynamicTabs || {}
			let entityParent = false

			utils.forEach(dynamicTabs, (tabConfig, resourceRegisterKey) => {
				if(tabConfig.type === 'ninja'){
					const ninjaConfig = tabConfig.ninjaConfig || {}

					if(!entityParent){
						entityParent = this.getResourceRegisterContent('entityParent')
					}
					if(!entityParent){
						console.error(`missing entityParent for ninja tab ${resourceRegisterKey}`)
						return false
					}
					if(!entityParent.resourceID){
						// the resourceID may be missing in cases of creation forms. in these cases a silent fail should be granted without any error messages.
						return false
					}
					const ninjaComponentType = ninjaConfig.ninjaComponentType || 'instance'
					let baseActionKey = `addNinjaTab_${ninjaComponentType}`
					// this is necessary to preserve the order of dynamic tabs in cases where later added tabs may be ready sooner than earlier added ones.
					const actionKey = `${baseActionKey}_${resourceRegisterKey}_${entityParent.resourceID}`
					// TODO: maybe use shortcut via addTab()?

					this.performAndStoreAction(
						actionKey,
						this.prepareAction(baseActionKey, undefined, {
							tabOptions: {
								title: 'MISSING .title',
								...(tabConfig.tabOptions || {}),
								grantAutoFocus: false
							},
							ninjaConfig: {
								...ninjaConfig,
								parentEntityType: ninjaConfig.ninjaType,
								parentEntityID: entityParent.resourceID,
							}
						}),
						false
					)
				} else {
					console.error('unkown dynamic tab type found', tabConfig.type)
				}
			})
		},

		onBeforeRender: function(){
			this.extendDynamicTabs()
		},

		updateStates: function(){
			// hide head if necessary
			if(utils.collectionSize(this.registry) < 2 && this.config.hideHeadContainingOneSingleElement){
				this.$.addClass('hideHead')
			} else {
				this.$.removeClass('hideHead')
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(utils.collectionSize(this.model.removeTabsWhenReady) > 0){
				for(const registerSecret in this.model.removeTabsWhenReady){
					this.removeTab(registerSecret)
				}
			}

			if(utils.collectionSize(this.registry) > 0){
				if(options.refresh){
					this.focusTab(this.model.activeRegisterSecret, true);
				}
				else if(this.config.startWithRegisterSecret && this.registry[this.config.startWithRegisterSecret]) {
					this.focusTab(this.config.startWithRegisterSecret, true);
				}
				else {
					this.focusTab(Object.keys(this.registry)[0], true);
				}
			}

			this.updateStates()
		}
	},
};
